import { render } from "./PerformanceReport.vue?vue&type=template&id=b650fb9e&ts=true"
import script from "./PerformanceReport.vue?vue&type=script&lang=ts"
export * from "./PerformanceReport.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/abdulkarim/workspace/public_html/joypurhost/pos2/pos2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__